





























































import { Component, Prop, Vue, Inject } from 'vue-property-decorator';
import {ToggleButton} from 'vue-js-toggle-button'
import {Vendor} from '@iabtcf/core/lib/model/gvl'


@Component({
  components: {
    ToggleButton,
  },
})

export default class VendorListItem extends Vue {

    consent = false;
    legitInterest = false;

    collapsed = true;
    collapseClass = "collapseButton collapseButtonRotatedUp"
    purposes = [];
    specialPurposes = [];
    features = [];
    specialFeatures = [];

    @Prop( { default:{ name:'none', id:0 } }) vendor!: Vendor;

    mounted() : void {

      //@ts-ignore
      let model : TCModel = window.__cmpTCModel;

      this.purposes = model.gvl.purposes;
      this.specialPurposes = model.gvl.specialPurposes;
      this.features = model.gvl.features;
      this.specialFeatures = model.gvl.specialFeatures;
      this.consent = model.vendorConsents.has( this.vendor.id );

      // console.log( "mounted" );
      // console.log( model );

      this.consent = model.vendorConsents.has( this.vendor.id );
      this.legitInterest = model.vendorLegitimateInterests.has( this.vendor.id );
    }

    changeLegitimateInterest( value: object, srcEvent: any ) {
      // @ts-ignore
      let model = window.__cmpTCModel;
    // @ts-ignore
      if ( value.value )
        model.vendorLegitimateInterests.set( this.vendor.id );
      else
        model.vendorLegitimateInterests.unset( this.vendor.id );

    // @ts-ignore
      this.legitInterest = value.value;

      // TODO: Emit dirty event here to enable button/save
      this.$emit('modelChangeEvent', true );
    }


    changeConsent( value: object, srcEvent: any ) {
      // @ts-ignore
      let model = window.__cmpTCModel;
    // @ts-ignore
      if ( value.value )
        model.vendorConsents.set( this.vendor.id );
      else
        model.vendorConsents.unset( this.vendor.id );

    // @ts-ignore
      this.consent = value.value;

      // TODO: Emit dirty event here to enable button/save
      this.$emit('modelChangeEvent', true );
    }

    expandCollapseClick() {
      // console.log("expandCollapseClick()")
      if ( this.collapsed )
        this.collapseClass = 'collapseButton collapseButtonRotatedDown';
      else
        this.collapseClass = 'collapseButton collapseButtonRotatedUp';
      this.collapsed = ! this.collapsed;
    }

}

